module.exports = __webpack_public_path__ + "assets/img/product-empty.ba3b5810.png";